import React from 'react'
import { observer } from 'mobx-react'
import { Row, Col, Button } from 'react-bootstrap'
import uniqBy from 'lodash/uniqBy'
import { getAppConfig, APPConfig,} from 'config/appConfig'
import {
  isB2B2C,
  checkIsSaleStarted,
  IS_BROWSER,
  i18nTranslate,
  currencyFormat,
  ApiContent,
  getLiveEventStatus,
  isExpressCheckout,
  enablePdpRedesign,
  isFeatureEnabled,
  getFavoritesEnabled,
} from 'src/utils'
import { renderPrysmBadgeContent } from 'src/views/components/Common/PrysmBadge'
import { IndividualProductQuantityAndButtons } from './IndividualProductQuantityAndButtons'
import { Link } from 'react-router-dom'
import {
  ProductAddToList,
  ProductSubscribeButton,
  ProductAddToCart,
} from './ProductButtons'
import { ProductSkuSelection } from './ProductSkuSelection'
import { ProductPrice } from './ProductPrice'
import { ProductShortDescription } from './ProductShortDescription'
import { SubscribeAndSaveText } from './SubscribeAndSaveText'
import { RetailPrice } from './RetailPrice'
import { ProductEarnAndRedeemText } from './ProductEarnAndRedeemText'
// import { ProductPromotion } from './ProductPromotion'
import { ProductTitle } from './ProductTitle'
import { PreOrderTime } from '../PreOrderTime'
import { productState } from 'src/views/components/BaseProductComponent/ProductState'
import { ProductItemId } from '../../ProductItemId'
import Freegifts from './FreeGift'
import ProductLeaderPreviewMessages from './ProductLeaderPreviewMessages'
import { cartContainer, customerContainer, storeContainer } from 'src/models'
import { V2BundlePDP } from 'src/views/components/BundlePDP/V2BundlePDP'
import { productDeps } from 'src/deps'
import { ProductFavoritesWithText } from './ProductFavoritesWithText'
import { V2ProductSVCV } from './V2ProductSVCV'
import { PDPUnitPrice, PriorPrice } from 'src/views/components/Price'
import { V2ProductQuantityAndButtons } from 'src/views/components/ProductComponents/V2ProductQuantityAndButtons/V2ProductQuantityAndButtons'
import { productStatusDeps } from 'src/views/components/ProductComponents/V2ProductQuantityAndButtons/ProductStatusDeps'
import './styles.scss'
import { ProductDetailSection } from '../ProductDetailSection'
import BundlesWithThisItems from '../BundlesWithThisItems/BundlesWithThisItems'
import PromotionOverImage from '../PromotionOverImage'

@observer
class ProductDetail extends React.Component {
  static contextType = ApiContent
  constructor(props, context) {
    super(props, context)
  }

  getAccountType = () => {
    if (IS_BROWSER) {
      return customerContainer.profileResponse?.accounts?.type || ''
    }
    return this?.context?.customerType
  }
  setCurrentSku = (data = {}) => {
    const { selectSkuById } = this.props
    const skuId = data?.identifier
    selectSkuById(skuId)
  }

  getIsBundleOrCollection = (
    isBundleOrCollection = false,
    businessRelationship = ''
  ) => {
    const { product = {} } = this.props
    const { isCollection = false, isBundle = false } = product
    if (isBundleOrCollection) {
      return isCollection || isBundle
    } else {
      return (
        !isCollection &&
        !isBundle &&
        getAppConfig()?.businessRelationship === businessRelationship
      )
    }
  }

  renderButtonsForB2B = handleAddToBag => {
    const { product, ...remainingProps } = this.props
    return (
      <Row noGutters className="w-100 py-3">
        <Col xs={12} md={12} className="pb-3">
          <ProductAddToCart
            {...product}
            {...remainingProps}
            handleAddToBag={handleAddToBag}
          />
        </Col>
        <Col xs={12} md={6} className="pb-1">
          <ProductAddToList {...this.props} />
        </Col>
        <Col xs={12} md={6}>
          <ProductSubscribeButton {...this.props} />
        </Col>
      </Row>
    )
  }

  renderQtyAndButtons = (edit = '') => {
    const {
      product = {},
      isBundleView = false,
      isSubscribeBtnDisabled,
    } = this.props
    const inventory = this.props?.inventory
    const { subscriptions = false, isBundle = false } = product
    return (
      <IndividualProductQuantityAndButtons
        {...this.props}
        inventory={inventory}
        edit={edit}
        isAddToCartDisable={cartContainer.isDisableAddToCart}
        isSubscribeBtnDisabled={isSubscribeBtnDisabled}
      />
    )
  }

  renderInventoryStatus = (
    messageToDisplay = '',
    isGreenBackOrderMessage = false,
    dataTestId = ''
  ) => {
    if (messageToDisplay) {
      return (
        <Row
          noGutters
          className="w-100 v2-inventory-message"
          data-testid={dataTestId}>
          <p
            className={
              isGreenBackOrderMessage
                ? 'backordered-danger-text'
                : enablePdpRedesign()
                  ? 'redesign-availability-text'
                  : 'availability-text-no-bg'
            }
            aria-live="polite"
            aria-atomic="true">
            {messageToDisplay}
          </p>
        </Row>
      )
    }
    return ''
  }

  renderProductLevelInventoryStatus = () => {
    const { product = {} } = this.props
    const productCount = this.props.productCount || 1
    const {
      messageToDisplay = '',
      isGreenBackOrderMessage = false,
      dataTestId = '',
    } = productStatusDeps.getV2ProductLevelInventoryStatus(
      product,
      productCount
    )
    if (
      messageToDisplay ===
      i18nTranslate(
        'pdp.userEligible',
        'You have reached your purchase limit for this product.',
        {
          nameSpace: 'ssr-resource',
        }
      )
    ) {
      return ''
    }
    return this.renderInventoryStatus(
      messageToDisplay,
      isGreenBackOrderMessage,
      dataTestId
    )
  }

  renderSaleText = () => {
    const { product = {} } = this.props
    const eventProperties = checkIsSaleStarted()

    if (
      IS_BROWSER &&
      product?.salesText &&
      eventProperties?.isSaleInProgress &&
      !eventProperties?.isSaleEnded
    ) {
      return <div className="mt-1 sales-text">{product?.salesText}</div>
    }
    return <></>
  }

  getBundleKitSavings = () => {
    const customerType = this.getAccountType()
    const isBAorPreferred =
      customerType === 'Brand Affiliate' ||
      customerType === 'Brand Affiliate - Business Entity' ||
      customerType === 'Preferred Customer/Member' ||
      false

    const unitValue = productDeps.getUnitValue(this.props)

    // return productState.currentlySelectedPriceOption ===
    //   'one-time-price-button'
    //   ? unitValue?.priceFacets?.['Regular Price']?.['Regular PriceDiscount']
    //   : unitValue['Sub Wholesale Price']?.bundleDiscount

    const priceFacetPattern = customerContainer?.isToShowMemberPrice(
      unitValue?.priceFacets
    )
      ? 'Member'
      : 'Wholesale'

    if (productState.currentlySelectedPriceOption === 'one-time-price-button') {
      if (isBAorPreferred) {
        if (priceFacetPattern === 'Member') {
          return unitValue?.priceFacets?.['Member Price']?.[
            'Member PriceDiscount'
          ]
        } else {
          return unitValue?.priceFacets?.['Wholesale Price']?.bundleDiscount
        }
      } else {
        return unitValue?.priceFacets?.['Regular Price']?.bundleDiscount
      }
    } else {
      if (isBAorPreferred) {
        if (priceFacetPattern === 'Member') {
          return unitValue?.priceFacets?.['Sub Member Price']?.[
            'Sub Member PriceDiscount'
          ]
        } else {
          return unitValue?.priceFacets?.['Sub Wholesale Price']?.bundleDiscount
        }
      } else {
        return unitValue?.priceFacets?.['Sub Retail Price']?.bundleDiscount
      }
    }
  }
  isNegativeDiscount = unitValue =>
    unitValue?.priceAfterDiscount > unitValue?.originalPrice

  renderBundleKitSavings = () => {
    const { product = {} } = this.props
    let bundleKitSaving = this.getBundleKitSavings() || 0

    const formattedSavings = currencyFormat({
      currency: product?.currency || '',
      price: bundleKitSaving,
    })
    const isSpecialType = product.type === 'bundle' || product.type === 'kit'
    const unitValue = productDeps.getUnitValue(this.props)
    if (
      bundleKitSaving &&
      bundleKitSaving > 0 &&
      isSpecialType &&
      !this.isNegativeDiscount(unitValue)
    ) {
      let messageToDisplay = ''
      let borderClassName = ''
      let dataTestId = ''

      if (product.type == 'bundle') {
        messageToDisplay = i18nTranslate(
          'pdp.bundleSave',
          'By Bundling You Save',
          {
            nameSpace: 'ssr-resource',
          }
        )
        borderClassName = 'product-promo-message-bundle-border'
        dataTestId = 'qa-pdp-bundling-you-save'
      } else {
        messageToDisplay = i18nTranslate('pdp.kitSave', 'With a Kit You Save', {
          nameSpace: 'ssr-resource',
        })
        borderClassName = 'product-promo-message-kit-border'
        dataTestId = 'qa-pdp-kit-you-save'
      }

      return (
        <Row
          noGutters
          className={`product-promo-message ${borderClassName}`}
          data-testid={dataTestId}>
          {messageToDisplay} -{' '}
          <span className="product-promo-savings">{formattedSavings}</span>
        </Row>
      )
    }
    return <></>
  }

  renderPrysmBadge = () => {
    return renderPrysmBadgeContent(this.props.product)
  }

  renderBundleKitSubItems = () => {
    const product = this.props.product || {}
    const inventory = productState.inventory || {}
    const inventoryStatus = productState.inventoryStatus || []
    const bundleType = product?.type || 'product'
    const isBundleView = this.props?.isBundleView || false
    const handleBundleView = this.props?.handleBundleView || {}
    return (
      <V2BundlePDP
        isExpressPDP={this.props?.isExpressPDP}
        product={product}
        bundleType={bundleType}
        isBundleView={isBundleView}
        inventory={inventory}
      />
    )
  }
  renderIncludedInThisKit = () => {
    const { product = {} } = this.props
    if (
      product.type == 'kit' &&
      product?.skuKit?.length &&
      !isExpressCheckout()
    ) {
      return (
        <Row
          noGutters
          className="product-kit-description"
          data-testid="qa-pdp-included-in-this-kit">
          <div>
            {i18nTranslate('pdp.includedInKit', 'Included in this Kit', {
              nameSpace: 'ssr-resource',
            })}
            :
            <ul className="product-kit-list">
              {product?.skuKit?.map((subProduct, index) => (
                <li key={'sub' + index}>
                  <Link to={productDeps.getSubProductLink(subProduct)}>
                    {subProduct?.previousSku?.properties?.name || ''}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </Row>
      )
    }
    return <></>
  }
  render() {
    const {
      product = {},
      subscribeAndSave = 0,
      isSubscribeBtnDisabled = false,
    } = this.props
    const {
      isBundle = false,
      isCollection = false,
      transactionPrice = 0,
      subscriptions = false,
      properties,
    } = product
    //let dispaySubscribeAndSave = subscribeAndSave > 0 ? true : false

    // const pdtResponse = product?.isBundle
    //   ? productState?.bundlePromotionResponse
    //   : product
    let isExclusive = ''
    if (product?.sku?.length === 1) {
      isExclusive = product?.sku?.[0]?.properties?.isExclusive || ''
    } else if (product?.sku?.length > 1) {
      const currentlySelectedSkuId = product?.skuId
      isExclusive =
        product?.sku?.find(sku => sku.identifier == currentlySelectedSkuId)
          ?.properties?.isExclusive || ''
    }
    let profileResponse = customerContainer.profileResponse || {}
    let accounts = profileResponse?.accounts || {}
    let accType = accounts?.type || ''
    // Safely determine if Direct Seller button should be enabled.
    // Guard against missing mocked implementation of productDeps.isDirectSellerProduct in tests.
    const enableDirectSellerButton =
      APPConfig?.getAppConfig()?.enableDirectSellerButton == 'true' &&
      (typeof productDeps?.isDirectSellerProduct === 'function'
        ? productDeps.isDirectSellerProduct(productState?.product)
        : false)
    const hideLoyaltyAlways =
      APPConfig?.getAppConfig()?.hideLoyaltyAlways === 'true'
    const hideLoyaltyForUS =
      APPConfig?.getAppConfig()?.hideLoyaltyForUS === 'true'
    const storeIdBasedOnCountry =
      storeContainer?.storeIDValue?.toLowerCase() || ''
    const isUS = storeIdBasedOnCountry === 'us'
    const isToHideLoyaltyForUS = hideLoyaltyForUS && isUS
    const hideLoyaltyText = hideLoyaltyAlways || isToHideLoyaltyForUS
    const userCountry = customerContainer.getUsersCountry()
    const enableNewPDPStyle =
      APPConfig?.getAppConfig()?.enableNewPDPStyle === 'true'
    const enableLiveEvent = getLiveEventStatus() === 'true'
    const promotion = productDeps.getPromotionNode(this.props, productState)

    const isPbomProduct = productDeps.isPbomProduct(product)
    const isNewPDP = enableNewPDPStyle && !enablePdpRedesign()
    const isBundleOrKit = product?.type === 'bundle' || product?.type === 'kit'
    const enablePriorPricing = isFeatureEnabled('priorPricing')
    const checkIfEnabled = {
      kit: isNewPDP && product.type === 'kit',
      bundle: isNewPDP && product.type === 'bundle',
    }

    return (
      <>
        <div id="zoom-image-wrap" />
        {enablePdpRedesign() && (
          <div className="fav-button-wrapper">
            <ProductFavoritesWithText
              product={this.props.product || {}}
              categoryId={this.props.categoryId || ''}
              location={this.props.location || {}}
              history={this.props.history || {}}
              className="product-fav-with-text-wrapper bg-transparent border-0 text-dark shadow-none"
              enableFavorites={getFavoritesEnabled()}
            />
            {enableNewPDPStyle &&
              (!isBundleOrKit || this.props?.isExpressPDP) && (
                <div className="quickshare bg-transparent border-0 text-dark shadow-none">
                  <V2ProductQuantityAndButtons
                    {...this.props}
                    show="quickShare"
                  />
                </div>
              )}
          </div>
        )}
        {this.renderPrysmBadge()}
        <div className="product-title-wrapper">
          <ProductTitle {...this.props?.product} />
        </div>
        {/* new pdp changes, bundle kit and mobileview */}
        <Row
          noGutters
          className={`${enablePdpRedesign() ? 'pdp-margin-top' : ''} itemid-and-fav-wrapper`}>
          {enableNewPDPStyle && (
            <ProductItemId
              isExpressPDP={this.props?.isExpressPDP}
              {...product}
            />
          )}
          {!enableNewPDPStyle && product.skuId && (
            <ProductItemId
              isExpressPDP={this.props?.isExpressPDP}
              {...product}
            />
          )}

          {enableNewPDPStyle && !enableLiveEvent && !enablePdpRedesign() && (
            <ProductFavoritesWithText
              product={this.props.product || {}}
              categoryId={this.props.categoryId || ''}
              location={this.props.location || {}}
              history={this.props.history || {}}
              className="product-fav-with-text-wrapper bg-transparent border-0 text-dark shadow-none"
              enableFavorites={getFavoritesEnabled()}
            />
          )}
        </Row>
        {enableDirectSellerButton && (
          <Button
            type="button"
            variant="contained"
            className="direct-seller-pdp-in-button"
            data-testid="qa-direct-seller-pdp">
            {i18nTranslate('direct-seller-pdp', 'Direct Seller')}
          </Button>
        )}
        {!enablePdpRedesign() && enableNewPDPStyle && (
          <V2ProductSVCV {...this.props} isFromPDP={true} />
        )}

        {enablePdpRedesign() && (
          <div className="promotion-above-price mb-2">
            <PromotionOverImage
              promoOnImageProps={
                promotion && promotion.length > 0
                  ? {
                      uniquePromotion: uniqBy(
                        Array.isArray(promotion)
                          ? promotion.filter(promo => promo.discount !== 0)
                          : [promotion].filter(promo => promo.discount !== 0),
                        promo => promo.message || promo.displayMessage
                      ),
                    }
                  : {}
              }
              isProductCard={false}
            />
          </div>
        )}

        {enablePdpRedesign() &&
          enableNewPDPStyle &&
          this.renderProductLevelInventoryStatus()}

        {/* to do for indivisual product price*/}
        {enableNewPDPStyle && !isBundleOrKit && (
          <PDPUnitPrice {...this.props} />
        )}

        <PreOrderTime {...product} className="" />
        {/* @##pdp_price unit price for both normal and kit */}
        {/* not for quickview */}
        {!enableNewPDPStyle && !product?.isBundle && (
          <ProductPrice
            {...product}
            isFromPDP={true}
            shouldShowKlarnaMessage={false}
          />
        )}
        {!enablePdpRedesign() &&
          enableNewPDPStyle &&
          product?.type == 'kit' && (
            <div className="kit-price-with-label">
              <PDPUnitPrice {...this.props} />
            </div>
          )}
        {enablePdpRedesign() && isBundleOrKit && (
          <div className="kit-price-with-label">
            <PDPUnitPrice {...this.props} />
          </div>
        )}

        {checkIfEnabled['kit'] && this.renderBundleKitSavings()}
        {enableNewPDPStyle && !isPbomProduct && this.renderIncludedInThisKit()}
        {!enablePdpRedesign() &&
          enableNewPDPStyle &&
          !isPbomProduct &&
          product.type === 'bundle' &&
          this.renderBundleKitSubItems()}
        {checkIfEnabled['bundle'] && this.renderBundleKitSavings()}
        {!enableNewPDPStyle && product?.isBundle && (
          <ProductPrice
            {...productState?.bundleUnitPriceResponse}
            type={product?.type}
            isBundle={product?.isBundle}
            isFromPDP={true}
            shouldShowKlarnaMessage={productDeps.isEnableAddToCartBtn(product)}
            shouldShowPaylaterMessage={true}
            userCountry={userCountry}
          />
        )}
        {this.renderSaleText()}
        {!enableNewPDPStyle &&
          (accType === 'Brand Affiliate' ||
            accType === 'Brand Affiliate - Business Entity' ||
            accType === 'Preferred Customer/Member') && (
            <RetailPrice {...product} />
          )}
        {enablePdpRedesign() && enableNewPDPStyle && (
          <V2ProductSVCV {...this.props} isFromPDP={true} />
        )}
        {enablePriorPricing && (
          <PriorPrice product={product} isBundle={isBundleOrKit} />
        )}

        {enablePdpRedesign() && <ProductDetailSection {...product} />}

        {!isSubscribeBtnDisabled && !product.isBundle && (
          <SubscribeAndSaveText
            subscribeAndSave={subscribeAndSave}
            {...product}
          />
        )}
        {!isSubscribeBtnDisabled && product.isBundle && (
          <SubscribeAndSaveText
            subscribeAndSave={subscribeAndSave}
            {...productState?.bundlePromotionResponse}
          />
        )}
        <ProductLeaderPreviewMessages
          isExclusive={isExclusive}
          {...this.props}
        />
        {/* <ProductRewards /> */}
        {!enablePdpRedesign() && <ProductSkuSelection {...this.props} />}
        {/* <ProductPromotion {...pdtResponse} isProductCard={true} /> */}
        {!hideLoyaltyText && <ProductEarnAndRedeemText {...product} />}
        <ProductShortDescription {...product} />
        {!enableNewPDPStyle &&
          (isB2B2C() || this.getIsBundleOrCollection(false, 'B2C')) &&
          this.renderQtyAndButtons('noEdit')}
        {enableNewPDPStyle && (!isBundleOrKit || this.props?.isExpressPDP) && (
          <V2ProductQuantityAndButtons
            {...this.props}
            isBundle={isBundle}></V2ProductQuantityAndButtons>
        )}
        {!enablePdpRedesign() &&
          enableNewPDPStyle &&
          !isPbomProduct &&
          this.props?.isExpressPDP &&
          product.type == 'kit' &&
          this.renderBundleKitSubItems()}
        {!enableNewPDPStyle && !product.isBundle && (
          <Freegifts {...productState?.pdpPromotionResponse} />
        )}
        {!enableNewPDPStyle && product.isBundle && (
          <Freegifts
            {...productState?.bundlePromotionResponse}
            isProductCard={true}
          />
        )}
        {enableNewPDPStyle && <Freegifts promotion={promotion} />}
        {enableNewPDPStyle &&
          product.type == 'bundle' &&
          this.props.renderBundlePriceAndButtons?.(this.props?.isExpressPDP)}
        {enableNewPDPStyle &&
          product.type == 'kit' &&
          this.props.renderBundlePriceAndButtons?.(this.props?.isExpressPDP)}
        {!enablePdpRedesign() &&
          enableNewPDPStyle &&
          !isPbomProduct &&
          !this.props?.isExpressPDP &&
          product.type == 'kit' &&
          this.renderBundleKitSubItems()}

      </>
    )
  }
}

export { ProductDetail }
export default ProductDetail
